var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layer-stack__body",style:({ width: _vm.$attrs.width, height: _vm.$attrs.height })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }